// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PlaybackRateController from "./playback_rate_controller"
application.register("playback-rate", PlaybackRateController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import WhatsappFabController from "./whatsapp_fab_controller"
application.register("whatsapp-fab", WhatsappFabController)
